import * as Yup from 'yup';

let validationSchema = Yup.object({
  skill_scoring_parameters_id: Yup.string(
    ('page.add_skill_scoring_parameters_id_required')
  )
    .trim()
    .required(('page.add_skill_scoring_parameters_id_required')),

  scores_note: Yup.string(
    ('page.add_scores_note_required')
  )
    .trim()
    .max(500, ('page.add_skills_scoring_note_exceed_500_character_required'))
    .required(('page.add_scores_note_required')),

  skills_scoring_option_id: Yup.string(
    ('page.add_skills_scoring_option_id_required')
  )
    .required(('page.add_skills_scoring_option_id_required'))
});

export default validationSchema;